/** Incrémente cette valeur à chaque nouvelle vague de News à montrer automatiquement. */
export const NEWS_VERSION = 45;

/** Nombre d’entrées dans le namespace `news` (`items.0` …). */
export const NEWS_ITEM_COUNT = 42;

/** Indices des items affichés via i18n (`news:items.{id}`). */
export const NEWS_ITEM_IDS = Array.from({ length: NEWS_ITEM_COUNT }, (_, i) => i);
